export const billingReviewApproveDto = {
    month: null,
    year: null,
}

export const billingReviewApproveItemDto = {
    organizationProductSubscriptionId: null,
}

export const billingDownloadFileDto = {
    month: null,
    year: null,
}